import { ActivityForm, NoteForm, CallForm, EmailForm, LetterForm } from './forms';

/**
 * Resolves the inline edit form type for an activity based on its activityType
 * and channel slug.
 *
 * @param {Object} activity
 * @param {Function} resolveChannel - returns channel object for activity, or null
 * @returns {'note'|'phone_manual'|'email'|'letter'|'activity'}
 */
export function resolveEditFormType(activity, resolveChannel) {
	if (activity.activityType === 'note') return 'note';
	const slug = resolveChannel(activity)?.slug;
	if (slug === 'phone_manual' || slug === 'phone_ai') return 'phone_manual';
	if (slug === 'email') return 'email';
	if (slug === 'letter') return 'letter';
	return 'activity';
}

const FORM_COMPONENTS = {
	activity: ActivityForm,
	note: NoteForm,
	phone_manual: CallForm,
	email: EmailForm,
	letter: LetterForm,
};

// Form types that need a channelTypeId prop (mapped to the slug used to look it up).
const CHANNEL_SLUG_BY_FORM_TYPE = {
	phone_manual: 'phone_manual',
	email: 'email',
	letter: 'letter',
};

/**
 * Renders an activity form by type, injecting channelTypeId when required.
 *
 * @param {Object} args
 * @param {string} args.formType
 * @param {Object} args.formProps - props common to all forms
 * @param {Function} args.getChannelTypeId - (slug) => string|null
 * @returns {JSX.Element|null}
 */
export function renderActivityForm({ formType, formProps, getChannelTypeId }) {
	const Component = FORM_COMPONENTS[formType];
	if (!Component) return null;
	const channelSlug = CHANNEL_SLUG_BY_FORM_TYPE[formType];
	const extraProps = channelSlug ? { channelTypeId: getChannelTypeId(channelSlug) } : {};
	return <Component {...formProps} {...extraProps} />;
}
